<template>
  <div class="about">
    <div id="head-page" class="meubles parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/meubles-03.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/meubles-01.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/meubles-02.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container">
      <div class="grid-x grid-margin-x">
				<avatar v-for="recipe in recipes.slice(0,200)" :recipe="recipe" />
      </div>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/Avatar'

	function shuffleArray(array) {
			for (let i = array.length - 1; i > 0; i--) {
					const j = Math.floor(Math.random() * (i + 1));
					[array[i], array[j]] = [array[j], array[i]];
			}
	}

  export default {
    components: { Avatar },
    computed: {
      bodies() { return ["blue", "fluffy", "green", "pink", "red", "yellow"]},
      eyeAccessories() { return ["none", "clown", "eyebrow", "mask", "minion", "monocle", "pirate", "star", "glass"]},
      eyes() { return ["fear", "fun", "furious", "suspicious", "think", "want"]},
      hats() { return ["none", "chef", "classy", "devilHorns", "feathers", "music", "snowCap", "unicornHorn", "santa", "magician", "bunny", "explorer", "king", "caregiver", "sharpBlue", "sharpYellow"]},
      mouths() { return ["bigSmile", "full", "poker", "reverse", "smile", "surprise"]},
      necks() { return ["none", "balloon", "beard", "blueScarf", "blueTie", "books", "redScarf", "redTie", "skyTie", "easter", "fiole", "santaBeard", "heartJewelry", "cake", "gift", "blueballoon", "sceptre"]},
      noses() { return ["none", "bigMustache", "dandyMustache", "clown", "upMustache", "mask", "pig"]},
      recipes() {
        let recipes = []
        for(let body of this.bodies) {
          for(let eyeAccessory of this.eyeAccessories) {
            for(let eye of this.eyes) {
              for(let hat of this.hats) {
                for(let mouth of this.mouths) {
                  for(let neck of this.necks) {
                    for(let nose of this.noses) {
                      recipes.push(`body-${body} eyeAccessory-${eyeAccessory} eye-${eye} hat-${hat} mouth-${mouth} neck-${neck} nose-${nose}`)
                    }
                  }
                }
              }
            }
          }
        }
        shuffleArray(recipes)
				return recipes
      }
    }
  }
</script>
